import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FaFolder, FaSearch, FaTimes } from "react-icons/fa";
import fetchData from "../custom_functions/fetchData";
import { url } from "../utils/config";
import { title } from "../utils/style";
import { BiArrowBack } from 'react-icons/bi';
import ImageSlider from "../reusable_components/imageSlider";
import Modal from "../reusable_components/Modal";

function FleetMedia() {
    const [appointment, setAppointment] = useState([]);
    const [page, setPage] = useState(1);
    const [isNextPage, setIsNextPage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [vin, setVin] = useState([]);
    const [state, setState] = useState("");
    const [images, setImages] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const toggleAppointmentFolder = (item) => {
        setState("vin");
        const data = item.fleet_work_estimates?.map((estimate, index) => ({
            id: index + 1,
            vin: estimate.fleet_customer_car?.vin,
            images: estimate.images || [],
        }));
        setVin(data);
    };

    const toggleVinFolder = (item) => {
        const data = item.images?.map((image) => { return image });
        setImages(data);
        setShowModal(true);
    };

    const fetchAppointment = async (pageNumber) => {
        try {
            setLoading(true);
            const response = await fetchData(`${url}/fleet_work_estimate_images?page=${pageNumber}&search=${searchTerm}`);
            setAppointment(response.data || []);
            setIsNextPage(response.isNextPage || false);
        } catch (error) {
            toast.error("Failed to fetch fleet media data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setState("estimate");
        const delayDebounce = setTimeout(() => {
            fetchAppointment(page);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [page, searchTerm]);



    return (
        <div className="overflow-y-auto p-4">
            <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
                <div className={title}>Fleet Media</div>
                {state === "estimate" &&
                    <div className="relative w-full md:w-64">
                        <input
                            type="text"
                            placeholder="Appointment ID..."
                            className="border border-gray-300 rounded-md px-3 pr-10 py-1.5 text-sm w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                        />
                        <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                        {searchTerm && (
                            <FaTimes
                                className="absolute right-8 top-1/2 transform -translate-y-1/2 text-red-400 text-sm"
                                onClick={() => {
                                    setSearchTerm("");
                                    setPage(1);
                                }}
                            />
                        )}
                    </div>
                }
            </div>


            <button onClick={() => setState("estimate")} className="text-sm text-blue-500 bg-gray-100 rounded-lg py-2 px-2 mb-2"><BiArrowBack /></button>






            {state === "estimate" &&
                (loading ? (
                    <div className="text-center py-10 text-sm text-gray-400">Loading...</div>
                ) : (
                    <>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                            {appointment.map((item) => (
                                <div
                                    key={item.id}
                                    onClick={() => toggleAppointmentFolder(item)}
                                    className="bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition duration-200 p-2 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100"
                                >
                                    <FaFolder className="text-blue-500 text-2xl mb-2" />
                                    <div className="text-sm font-semibold text-gray-800">
                                        FAP0000{item.id}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {item.fleet_work_estimates.length} Item
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination Controls */}
                        <div className="flex justify-center items-center gap-4 mt-8">
                            <button
                                className="text-sm px-4 py-1.5 rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-blue-500"
                                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                                disabled={page === 1}
                            >
                                Previous
                            </button>
                            <span className="text-sm text-gray-600">Page {page}</span>
                            <button
                                className="text-sm px-4 py-1.5 rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-blue-500"
                                onClick={() => setPage((prev) => prev + 1)}
                                disabled={!isNextPage}
                            >
                                Next
                            </button>
                        </div>
                    </>
                )
                )
            }




            {state === "vin" && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {vin.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => toggleVinFolder(item)}
                            className="bg-gray-50 border border-gray-200 rounded-xl shadow-sm p-2 flex flex-col items-center"
                        >
                            <FaFolder className="text-blue-500 text-2xl mb-2" />
                            <div className="text-sm font-semibold text-gray-800 mb-2">
                                {item.vin}
                            </div>
                            <div className="text-xs text-gray-500">
                                {item.images.length} Images
                            </div>
                        </div>
                    ))}
                </div>
            )}


            {showModal &&
                <Modal setShowModal={setShowModal} component={() => (
                    <ImageSlider
                        images={images}
                        imageUrlInfix="fleet_estimate_images"
                    />
                )} />
            }



        </div>
    );
}

export default FleetMedia;
